import Home from "./pages/home";
import ProjectDetails from "./pages/ProjectDetails";
import ServicePage from "./pages/ServicesPage";
import Header from "./components/Header/header";
import Footer from "./components/Footer/Footer";
import HowWeWork from "./pages/HowWeWork";
import Specialists from "./pages/Specialists";
import QuoteForm from "./pages/QuoteForm";
import ProjectsPage from "./pages/ProjectsPage";
import FAQPage from "./pages/FAQPage";
import LegalPage from "./pages/LegalPage";
import AdminDashboard from "./admin/pages/AdminDashboard";
import AdminLogin from "./admin/pages/AdminLogin";
import FurniturePlanner from "./pages/FurniturePlanner";
import QuotationTool from "./pages/QuotationTool";
import CataloguePage from "./admin/pages/CataloguePage";
import QuotePricingPage from "./admin/pages/QuotePricingPage";

const PROJECT_SLUGS = [
  "shinde-house",
  "stellar-homes",
  "bunglow-interior",
  "riverstone-residence",
  "up-coming-project",
  "upcoming-residential-project",

  // Future projects - .
  // "limestone-residence",
  // "white-court-house",
  // "monochrome-residence",
  // "concrete-and-wood",
  "graphite-kitchen",
  // "warm-stone-home",
  // "atelier-minimal",
  // "quiet-geometry",
  // "earth-residence",
  // "frame-house",
];

function App() {
  const path = window.location.pathname;
  const cleanPath = path.replace(/\/$/, ""); 

  if (cleanPath === "/admin/login") {
    return <AdminLogin />;
  }

  if (cleanPath === "/admin") {
    return <AdminDashboard />;
  }

  if (cleanPath === "/admin/catalogue") {
    return <CataloguePage />;
  }

  if (cleanPath === "/admin/quote-pricing") {
    return <QuotePricingPage />;
  }

  if (cleanPath === "/quotation-tool") {
    return <QuotationTool />;
  }

  if (cleanPath === "/furniture-planner") {
    return (
      <div className="shell">
        <Header />
        <main>
          <FurniturePlanner />
        </main>
        <Footer />
      </div>
    );
  }

  if (path === "/ServicePage" || path === "/services") {
    return (
      <div className="shell">
        <Header />
        <main>
          <ServicePage />
        </main>
        <Footer />
      </div>
    );
  }


  if (cleanPath === "/how-we-work") {
  return (
    <div className="shell">
      <Header />

      <main>
        <HowWeWork />
      </main>

      <Footer />
    </div>
  );
}


  if (cleanPath === "/contact") {
  return (
    <div className="shell">
      <Header />

      <main>
        <QuoteForm />
      </main>

      <Footer />
    </div>
  );
}

  if (cleanPath === "/specialists") {
  return (
    <div className="shell">
      <Header />

      <main>
        <Specialists />
      </main>

      <Footer />
    </div>
  );
}

  if (cleanPath === "/faqs") {
  return (
    <div className="shell">
      <Header />

      <main>
        <FAQPage />
      </main>
    </div>
  );
}

  const legalPage = {
    "/privacy": "privacy",
    "/help": "help",
    "/cookies-policy": "cookies",
    "/credits": "credits",
  }[cleanPath];

  if (legalPage) {
    return (
      <div className="shell">
        <Header />
        <main>
          <LegalPage page={legalPage} />
        </main>
        <Footer />
      </div>
    );
  }

  if (cleanPath === "/project" || cleanPath === "/projects") {
    return (
      <div className="shell">
        <Header />
        <main>
          <ProjectsPage />
        </main>
        <Footer />
      </div>
    );
  }


  const isProjectPage = PROJECT_SLUGS.some(
    (slug) => cleanPath === `/${slug}`
  );

  if (isProjectPage) {
    return (
      <div className="shell">
        <Header />
        <main>
          <ProjectDetails />
        </main>
        <Footer />
      </div>
    );
  }

  return <Home />;
}

export default App;